import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { SemovelProvider } from '../../providers/semovel/semovel';

@Component({
  selector: 'page-pedido-view',
  templateUrl: 'pedido-view.html',
})
export class PedidoViewPage {
  pedido:any;

  constructor(public navCtrl: NavController, public navParams: NavParams, private server:SemovelProvider) {
    this.pedido = navParams.get('pedido');
  }

  getPodeCancelar(){
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/pages/pedido-view/pedido-view.ts